<template>
  <div>
    <a-modal v-model:visible="visible" :title="record.name+'：品牌管理'" :cancelButtonProps="{ style: { display: 'none' } }" okText="保存" @ok="handleOk" :afterClose="closeModal" width="70vw" :maskClosable="false">
      <div class="brand-modal-container">
        <!-- 左侧标签栏 -->
        <div class="brand-sidebar">
          <div v-for="(tab, index) in tabs" :key="index" class="sidebar-tab" :class="{ active: activeKey === tab.name }" @click="handleTabClick(tab.name)">
            <span class="tab-name">{{ tab.name }}</span>
            <div class="tab-actions">
              <a-button size="small" type="text" @click.stop="moveTabUp(index)" :disabled="index === 0">↑</a-button>
              <a-button size="small" type="text" @click.stop="moveTabDown(index)" :disabled="index === tabs.length - 1">↓</a-button>
              <a-popconfirm title="确定要删除这个标签吗？删除后无法恢复。" ok-text="删除" cancel-text="取消" @confirm="deleteTab(tab,index)">
                <a-button size="small" type="danger" @click.stop>×</a-button>
              </a-popconfirm>

            </div>
          </div>
          <div class="add-tab-btn" @click="addNewTab">+ 新增标签</div>

        </div>

        <!-- 右侧内容区 -->
        <div v-if="tabs.length > 0" class="brand-content">
          <!-- 头部信息 -->
          <div class="content-header">
            <div class="header-upload-and-name">
              <!-- <a-upload v-model:file-list="currentItem.imageList" action="/api/upload" list-type="picture-card" :custom-request="uploadImage" class="upload-wrapper">
                <div>
                  <a-icon type="plus" />
                  <div class="ant-upload-text">上传</div>
                </div>
              </a-upload> -->
              <a-upload class="upload-wrapper" v-model:file-list="fileList" name="file" list-type="picture-card" :show-upload-list="false" :custom-request="uploadCurrentItemImage" :before-upload="beforeUpload">
                <img v-if="currentItem.imageUuid" :src="imageUrl+currentItem.imageUuid" alt="avatar" style="width: 100%; height: 100%; object-fit: cover;" />
                <div v-else>
                  <loading-outlined v-if="loading"></loading-outlined>
                  <plus-outlined v-else></plus-outlined>
                  <div class="ant-upload-text">{{inputs?.headImage ? '更换图片' : '上传图片'}}</div>
                </div>
              </a-upload>
              <div class="name-input-group">
                <label class="input-label">名称：</label>
                <a-input v-model:value="currentItem.name" class="name-input" />
              </div>
            </div>

          </div>

          <!-- 内容详情列表（可编辑） -->
          <div class="details-section">
            <div v-for="(item, idx) in currentItem.items" :key="idx" class="detail-item-editable">
              <!-- 图标：仅在非纯文本输入时显示 -->
              <!-- <div v-if="item.category !== 'Text'" class="item-icon">
                <a-icon type="picture" />
              </div> -->

              <!-- 文本输入 -->
              <div v-if="item.category === 'Text'" class="text-input-area">
                <a-textarea v-model:value="item.detail" :auto-size="{ minRows: 2, maxRows: 6 }" placeholder="请输入文本内容..." />
              </div>

              <!-- 图片上传 -->
              <div v-else class="image-upload-area">

                <a-upload v-model:file-list="item.uploadList" name="file" list-type="picture-card" :show-upload-list="false" :custom-request="(data) => uploadItemsImage(item)(data)" :before-upload="beforeUpload">
                  <img v-if="item.detail" :src="imageUrl+item.detail" alt="avatar" style="width: 100%; height: 100%; object-fit: cover;" />
                  <div v-else>
                    <loading-outlined v-if="loading"></loading-outlined>
                    <plus-outlined v-else></plus-outlined>
                    <div class="ant-upload-text">{{inputs?.headImage ? '更换图片' : '上传图片'}}</div>
                  </div>
                </a-upload>
                <!-- 显示已上传图片 -->
                <!-- <img v-if="item.detail" :src="imageUrl+item.detail" alt="已上传" class="uploaded-preview" /> -->
              </div>

              <!-- 操作按钮 -->
              <div class="item-actions">
                <a-button size="small" type="default" @click="moveUp(idx)" :disabled="idx === 0">↑</a-button>
                <a-button size="small" type="default" @click="moveDown(idx)" :disabled="idx === currentItem.items.length - 1">↓</a-button>
                <a-button size="small" type="danger" @click="removeItem(idx)">删除</a-button>
              </div>
            </div>

            <!-- 添加内容按钮 -->
            <div class="add-content-actions">
              <a-button type="primary" size="small" @click="addItem('Text')">增加文本</a-button>
              <a-button type="primary" size="small" @click="addItem('Image')">增加图片</a-button>
            </div>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { GetList, Edit, saveOrder, Delete, SaveItems, Add } from "/src/api/linkEnterprise.js";
import { Upload } from "/src/api/upload.js";
export default {
  name: 'BrandManagementModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    record: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      visible: this.modelValue,
      activeKey: '',
      imageUrl: '/api/file/img/', // 替换为真实域名
      tabs: [],
      currentItem: {}
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    modelValue(val) {
      this.visible = val;

    },
    async record(val) {
      await this.init()
      if (val && this.tabs.length > 0) {
        this.activeKey = this.activeKey || this.tabs[0].name;
        this.handleTabClick(this.activeKey);
      }
    }
  },
  methods: {
    async init() {
      await this.getList()
    },
    async getList() {
      if (!this.record.groupId) {
        return
      }
      let parmas = {
        objectId: this.record.groupId,
        objectCategory: this.record.objectCategory,
        category: this.record.category
      }
      console.log(parmas);

      let res = await GetList(parmas)
      if (res.errCode == 0) {
        console.log("GetList", res);
        //没有items则初始化一个空数组
        res.data.forEach(tab => {
          if (!tab.items) {
            tab.items = []
          }
          // 为每个图片项初始化 uploadList
          tab.items.forEach(item => {
            if (item.category === 'Image') {
              this.initUploadList(item);
            }
          });
        });
        this.tabs = res.data


        // this.handleTabClick(this.activeKey);
      }

    },
    handleTabClick(name) {
      const tab = this.tabs.find(t => t.name === name);
      if (tab) {
        const cloned = JSON.parse(JSON.stringify(tab));
        // 为每个图片项初始化 uploadList
        if (cloned.items) {
          cloned.items.forEach(item => {
            if (item.category === 'Image') {
              this.initUploadList(item);
            }
          });
        }
        this.currentItem = cloned;
        this.activeKey = name;
      }
    },
    addNewTab() {
      // 如果有未保存的标签，提示先保存，不允许新增（未保存的标签没有 id）
      if (this.tabs.some(tab => !tab.id)) {
        this.$message.warning('请先保存新建的标签');
        return;
      }

      // 生成唯一名称
      let baseName = '新标签';
      let index = this.tabs.length + 1;
      let newName = `${baseName}${index}`;

      // 检查是否重名，如果重名则递增编号
      while (this.tabs.some(tab => tab.name === newName)) {
        index++;
        newName = `${baseName}${index}`;
      }

      // 添加新标签
      const newTab = { name: newName, items: [], imageList: [] };
      this.tabs.push(newTab);
      this.currentItem = JSON.parse(JSON.stringify(newTab));
      this.activeKey = newName;
    },
    moveTabUp(index) {
      if (index > 0) {
        // 使用 splice 交换两个元素
        const temp = this.tabs[index];
        this.tabs.splice(index, 1, this.tabs[index - 1]);
        this.tabs.splice(index - 1, 1, temp);

        this.activeKey = this.tabs[index - 1].name;
        this.handleTabClick(this.activeKey);
      }
      this.saveOrder()
    },
    moveTabDown(index) {
      if (index < this.tabs.length - 1) {
        const temp = this.tabs[index];
        this.tabs.splice(index, 1, this.tabs[index + 1]);
        this.tabs.splice(index + 1, 1, temp);

        this.activeKey = this.tabs[index + 1].name;
        this.handleTabClick(this.activeKey);
      }
      this.saveOrder()
    },
    async saveOrder() {
      // 保存当前标签
      //id排序
      let parmas = this.tabs.map(tab => tab.id).filter(id => id) // 过滤掉没有id的标签
      let res = await saveOrder(parmas)
      // console.log("保存排序", res);

    },
    async deleteTab(tab, index) {
      // 1. 校验：至少保留一个标签
      if (this.tabs.length <= 1) {
        this.$message.warning('至少保留一个标签');
        return;
      }
      console.log(tab);

      const deletedName = tab.name;

      // 2. 如果有 id，先调用后端删除接口
      if (tab.id) {
        let res = await Delete({ id: tab.id });
        if (res.errCode !== 0) {
          this.$message.error('删除失败：' + (res.message || '未知错误'));
          return; // 接口失败，阻止删除
        }
      }

      // 3. 接口成功或无 id（本地未保存的 tab），才从数组中删除
      this.tabs.splice(index, 1);

      // 4. 如果删除的是当前激活的 tab，切换到其他 tab
      if (this.activeKey === deletedName) {
        const newIndex = index > 0 ? index - 1 : 0;
        this.activeKey = this.tabs[newIndex].name;
        this.handleTabClick(this.activeKey); // 触发内容更新
      }

      // 5. 提示成功
      this.$message.success('标签已删除');
    },
    addItem(type) {
      const newItem = {
        category: type,
        detail: '',
        relationId: null,
        uploadList: [] // 初始化为空
      };
      this.currentItem.items.push(newItem);
    },
    removeItem(index) {
      this.currentItem.items.splice(index, 1);
    },
    moveUp(index) {
      if (index > 0) {
        const temp = this.currentItem.items[index];
        this.currentItem.items[index] = this.currentItem.items[index - 1];
        this.currentItem.items[index - 1] = temp;
      }
    },
    moveDown(index) {
      if (index < this.currentItem.items.length - 1) {
        const temp = this.currentItem.items[index];
        this.currentItem.items[index] = this.currentItem.items[index + 1];
        this.currentItem.items[index + 1] = temp;
      }
    },
    initUploadList(item) {
      if (!item.uploadList) {
        item.uploadList = item.detail ? [{ url: this.imageUrl + item.detail, name: '图片', uid: '-1' }] : [];
      }
    },
    async uploadCurrentItemImage({ file, onSuccess, onError }) {
      let formData = new FormData();
      formData.append('file', file);
      formData.append('category', 'portrait');
      formData.append('system', 'true');

      let res = await Upload(formData); // 调用你封装的 Upload 方法
      this.currentItem.imageUuid = res.data
      console.log("currentItem.imageUuid", this.currentItem.imageUuid);
    },
    uploadItemsImage(item) {
      return async ({ file, onSuccess, onError }) => {
        let formData = new FormData();
        formData.append('file', file);
        formData.append('category', 'portrait');
        formData.append('system', 'true');

        try {
          let res = await Upload(formData);
          console.log("图片上传", res.data);
          item.detail = res.data;

          // 更新 uploadList 以便 UI 显示
          item.uploadList = [{
            uid: file.uid,
            name: file.name,
            status: 'done',
            url: this.imageUrl + res.data
          }];

          onSuccess(res); // 必须调用 onSuccess 通知组件上传成功
        } catch (err) {
          console.error("上传失败", err);
          item.uploadList = [{
            uid: file.uid,
            name: file.name,
            status: 'error'
          }];
          onError(err); // 必须调用 onError 通知组件上传失败
        }
      };
    },
    async handleOk() {
      let type;
      if (!this.currentItem.name) {
        this.$message.warning('请输入名称');
        return;
      }

      let parmas = {
        name: this.currentItem.name,
        imageUuid: this.currentItem.imageUuid,
      };

      let res;
      if (this.currentItem.id) {
        parmas.id = this.currentItem.id;
        res = await Edit(parmas);
        type = "edit"
      } else {
        parmas.objectId = this.record.groupId;
        parmas.objectCategory = this.record.objectCategory;
        parmas.category = this.record.category;
        parmas.items = this.currentItem.items;
        res = await Add(parmas);
        type = "add"
      }
      console.log("返回id", res);

      if (res.errCode !== 0) {
        this.$message.error('保存失败：' + (res.message || '未知错误'));
        return;
      }

      // 重要：更新 currentItem.id（如果是新增）
      if (!this.currentItem.id && res.data?.id) {
        this.currentItem.id = res.data.id;
      }

      //更新activeKey
      this.activeKey = this.currentItem.name;

      //  先保存 items，不要先 getList()
      if (type === 'add') {
        this.$message.success('保存成功');
        this.getList();
      } else {
        await this.saveItems(); // 确保使用当前编辑的数据
      }
    },
    async saveItems() {
      if (!this.currentItem.id) {
        this.$message.warning('请先保存标签，再保存内容项');
        return;
      }

      const parmas = {
        id: this.currentItem.id,
        items: this.currentItem.items.map(item => ({
          category: item.category,
          detail: item.detail,
          relationId: item.relationId || null
        }))
      };

      console.log('saveItems 参数：', parmas); // ✅ 调试用

      try {
        const res = await SaveItems(parmas);
        if (res.errCode === 0) {
          this.$message.success('保存成功');
          // ✅ 保存成功后再刷新列表
          await this.getList();
          // 可选：重新激活当前 tab
          this.handleTabClick(this.activeKey);
        } else {
          this.$message.error('保存内容失败：' + (res.message || '未知错误'));
        }
      } catch (error) {
        console.error('saveItems 调用失败：', error);
        this.$message.error('网络错误，保存失败');
      }
    },
    closeModal() {
      this.$emit('update:modelValue', false);
      //数据初始化
      this.currentItem = {};
      this.activeKey = this.tabs.length > 0 ? this.tabs[0].name : '';
      this.tabs = [];
    }
  }
};
</script>

<style scoped>
.brand-modal-container {
  display: flex;
  height: 70vh;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  overflow: hidden;
}

/* ========== 左侧标签栏 ========== */
.brand-sidebar {
  width: 220px;
  background-color: #f8f9fa;
  border-right: 1px solid #e8e8e8;
  padding: 12px 0;
  overflow-y: auto;
}

.sidebar-tab {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  margin: 0 6px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  border-radius: 4px;
  border: 1px solid #e8e8e8;
  background-color: #fff;
  transition: all 0.2s ease;
}

.sidebar-tab:hover {
  background-color: #e6f7ff;
  border-color: #91d5ff;
}

.sidebar-tab.active {
  background-color: #1890ff;
  color: #fff;
  border-color: #1890ff;
  font-weight: 500;
}

.sidebar-tab.active .ant-btn {
  color: #fff;
}

.sidebar-tab.active .ant-btn[disabled] {
  color: rgba(255, 255, 255, 0.3);
}
.tab-name {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tab-actions {
  display: flex;
  gap: 4px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.sidebar-tab:hover .tab-actions,
.sidebar-tab.active .tab-actions {
  opacity: 1;
}

.add-tab-btn {
  margin: 12px 10px;
  padding: 8px 12px;
  text-align: center;
  color: #1890ff;
  font-size: 13px;
  border: 1px dashed #1890ff;
  border-radius: 4px;
  background-color: #e6f7ff;
  cursor: pointer;
  transition: background-color 0.2s;
}

.add-tab-btn:hover {
  background-color: #bae7ff;
}

/* ========== 右侧内容区 ========== */
.brand-content {
  flex: 1;
  padding: 16px;
  background-color: #fdfdfd;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.content-header {
  padding: 16px;
  margin-bottom: 16px;
  background-color: #f5f5f5;
  border-radius: 6px;
  border: 1px solid #e8e8e8;
}

.header-upload-and-name {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  gap: 20px;
}

.upload-wrapper {
  width: fit-content;
}

.name-input-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.input-label {
  font-size: 14px;
  color: #333;
}

.name-input {
  width: 300px;
}

.header-actions {
  display: flex;
  justify-content: center;
  gap: 10px;
}

/* ========== 内容详情区 ========== */
.details-section {
  flex: 1;
  overflow-y: auto;
}

.detail-item-editable {
  display: flex;
  align-items: flex-start;
  padding: 12px;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  background-color: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  margin-bottom: 12px;
  gap: 12px;
}

.detail-item-editable .item-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f0f0f0;
  border-radius: 4px;
  font-size: 18px;
  color: #595959;
  flex-shrink: 0;
}

.text-input-area {
  flex: 1;
  min-width: 0;
}

.text-input-area .ant-textarea {
  font-size: 14px;
  line-height: 1.5;
}

.image-upload-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.image-upload-area .ant-upload-picture-card-wrapper {
  width: fit-content;
}

.uploaded-preview {
  max-width: 200px;
  max-height: 150px;
  border-radius: 4px;
  border: 1px solid #eee;
  margin-top: 4px;
}

.item-actions {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-left: 12px;
  min-width: 70px;
}

.item-actions .ant-btn {
  padding-left: 8px;
  padding-right: 8px;
  min-width: 32px;
}

/* ========== 底部操作按钮 ========== */
.add-content-actions {
  margin-top: 16px;
  display: flex;
  justify-content: center;
  gap: 10px;
}
</style>